import { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { PageLayout } from './components';
import { CalendarRoute, InternalUser, NotFoundRoute, TrackerRoute, VesselRoute } from './routes';

const App = () => {
    const navigate = useNavigate();
    useEffect(() => {
        (async () => {
            navigate('/');
        })();
    }, []);
    return (
        <Routes>
            <Route path="/" element={<PageLayout />}>
                <Route index element={<TrackerRoute />} />
                <Route path="calendar" element={<CalendarRoute />} />
                <Route path="vessel" element={<VesselRoute />} />
                <Route path="internal" element={<InternalUser />} />
            </Route>
            <Route path="*" element={<NotFoundRoute />} />
        </Routes>
    );
};

export default App;
